/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AggregateResult,
  Car,
  CarComplianceDocument,
  CarForm,
  CarHistoryEvent,
  CarInProperty,
  CarRequest,
  CarViolationsResponse,
  CarsAggregateRetrieveParams,
  CarsCertificatesListParams,
  CarsComplianceDocumentsListParams,
  CarsFormListParams,
  CarsHistoryListParams,
  CarsKnowledgeListParams,
  CarsKpisByPropertyIdListParams,
  CarsListParams,
  CertificateBasic,
  KnowledgeEntry,
  KnowledgeEntryCarCreateRequest,
  KnowledgeEntryCreated,
  PatchedCarRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type carsListResponse200 = {
  data: Car[]
  status: 200
}

export type carsListResponseSuccess = (carsListResponse200) & {
  headers: Headers;
};
;

export type carsListResponse = (carsListResponseSuccess)

export const getCarsListUrl = (params?: CarsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/?${stringifiedParams}` : `/api/v1/cars/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsList = async (params?: CarsListParams, options?: RequestInit): Promise<carsListResponse> => {

  return customFetch<carsListResponse>(getCarsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsCreateResponse201 = {
  data: Car
  status: 201
}

export type carsCreateResponseSuccess = (carsCreateResponse201) & {
  headers: Headers;
};
;

export type carsCreateResponse = (carsCreateResponseSuccess)

export const getCarsCreateUrl = () => {




  return `/api/v1/cars/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsCreate = async (carRequest: CarRequest, options?: RequestInit): Promise<carsCreateResponse> => {

  return customFetch<carsCreateResponse>(getCarsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(carRequest)
  }
);}


export type carsKnowledgeListResponse200 = {
  data: KnowledgeEntry[]
  status: 200
}

export type carsKnowledgeListResponseSuccess = (carsKnowledgeListResponse200) & {
  headers: Headers;
};
;

export type carsKnowledgeListResponse = (carsKnowledgeListResponseSuccess)

export const getCarsKnowledgeListUrl = (carPk: string,
    params?: CarsKnowledgeListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/${carPk}/knowledge/?${stringifiedParams}` : `/api/v1/cars/${carPk}/knowledge/`
}

/**
 * One car's knowledge. Change or delete an entry through its property.
 */
export const carsKnowledgeList = async (carPk: string,
    params?: CarsKnowledgeListParams, options?: RequestInit): Promise<carsKnowledgeListResponse> => {

  return customFetch<carsKnowledgeListResponse>(getCarsKnowledgeListUrl(carPk,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsKnowledgeCreateResponse201 = {
  data: KnowledgeEntryCreated
  status: 201
}

export type carsKnowledgeCreateResponseSuccess = (carsKnowledgeCreateResponse201) & {
  headers: Headers;
};
;

export type carsKnowledgeCreateResponse = (carsKnowledgeCreateResponseSuccess)

export const getCarsKnowledgeCreateUrl = (carPk: string,) => {




  return `/api/v1/cars/${carPk}/knowledge/`
}

/**
 * One car's knowledge. Change or delete an entry through its property.
 */
export const carsKnowledgeCreate = async (carPk: string,
    knowledgeEntryCarCreateRequest: KnowledgeEntryCarCreateRequest, options?: RequestInit): Promise<carsKnowledgeCreateResponse> => {

  return customFetch<carsKnowledgeCreateResponse>(getCarsKnowledgeCreateUrl(carPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(knowledgeEntryCarCreateRequest)
  }
);}


export type carsRetrieveResponse200 = {
  data: Car
  status: 200
}

export type carsRetrieveResponseSuccess = (carsRetrieveResponse200) & {
  headers: Headers;
};
;

export type carsRetrieveResponse = (carsRetrieveResponseSuccess)

export const getCarsRetrieveUrl = (id: string,) => {




  return `/api/v1/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsRetrieve = async (id: string, options?: RequestInit): Promise<carsRetrieveResponse> => {

  return customFetch<carsRetrieveResponse>(getCarsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsUpdateResponse200 = {
  data: Car
  status: 200
}

export type carsUpdateResponseSuccess = (carsUpdateResponse200) & {
  headers: Headers;
};
;

export type carsUpdateResponse = (carsUpdateResponseSuccess)

export const getCarsUpdateUrl = (id: string,) => {




  return `/api/v1/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsUpdate = async (id: string,
    carRequest: CarRequest, options?: RequestInit): Promise<carsUpdateResponse> => {

  return customFetch<carsUpdateResponse>(getCarsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(carRequest)
  }
);}


export type carsPartialUpdateResponse200 = {
  data: Car
  status: 200
}

export type carsPartialUpdateResponseSuccess = (carsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type carsPartialUpdateResponse = (carsPartialUpdateResponseSuccess)

export const getCarsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsPartialUpdate = async (id: string,
    patchedCarRequest?: PatchedCarRequest, options?: RequestInit): Promise<carsPartialUpdateResponse> => {

  return customFetch<carsPartialUpdateResponse>(getCarsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCarRequest)
  }
);}


export type carsDestroyResponse204 = {
  data: void
  status: 204
}

export type carsDestroyResponseSuccess = (carsDestroyResponse204) & {
  headers: Headers;
};
;

export type carsDestroyResponse = (carsDestroyResponseSuccess)

export const getCarsDestroyUrl = (id: string,) => {




  return `/api/v1/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsDestroy = async (id: string, options?: RequestInit): Promise<carsDestroyResponse> => {

  return customFetch<carsDestroyResponse>(getCarsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type carsCertificatesListResponse200 = {
  data: CertificateBasic[]
  status: 200
}

export type carsCertificatesListResponseSuccess = (carsCertificatesListResponse200) & {
  headers: Headers;
};
;

export type carsCertificatesListResponse = (carsCertificatesListResponseSuccess)

export const getCarsCertificatesListUrl = (id: string,
    params?: CarsCertificatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/${id}/certificates/?${stringifiedParams}` : `/api/v1/cars/${id}/certificates/`
}

/**
 * Get basic certificate information for a specific car.
 * URL: /api/v1/cars/{car_id}/certificates/
 */
export const carsCertificatesList = async (id: string,
    params?: CarsCertificatesListParams, options?: RequestInit): Promise<carsCertificatesListResponse> => {

  return customFetch<carsCertificatesListResponse>(getCarsCertificatesListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsComplianceDocumentsListResponse200 = {
  data: CarComplianceDocument[]
  status: 200
}

export type carsComplianceDocumentsListResponseSuccess = (carsComplianceDocumentsListResponse200) & {
  headers: Headers;
};
;

export type carsComplianceDocumentsListResponse = (carsComplianceDocumentsListResponseSuccess)

export const getCarsComplianceDocumentsListUrl = (id: string,
    params?: CarsComplianceDocumentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/${id}/compliance_documents/?${stringifiedParams}` : `/api/v1/cars/${id}/compliance_documents/`
}

/**
 * Get compliance documents (certificates, inspection reports, violations,
 * and contracts) for a specific car.
 * URL: /api/v1/cars/{car_id}/compliance_documents/
 */
export const carsComplianceDocumentsList = async (id: string,
    params?: CarsComplianceDocumentsListParams, options?: RequestInit): Promise<carsComplianceDocumentsListResponse> => {

  return customFetch<carsComplianceDocumentsListResponse>(getCarsComplianceDocumentsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsHistoryListResponse200 = {
  data: CarHistoryEvent[]
  status: 200
}

export type carsHistoryListResponseSuccess = (carsHistoryListResponse200) & {
  headers: Headers;
};
;

export type carsHistoryListResponse = (carsHistoryListResponseSuccess)

export const getCarsHistoryListUrl = (id: string,
    params?: CarsHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/${id}/history/?${stringifiedParams}` : `/api/v1/cars/${id}/history/`
}

/**
 * Asset history: every record tagged to this car as a normalized,
 * date-sorted timeline (invoices, proposals, credits, tickets, violations,
 * inspection reports, certificates, and the governing contracts).
 *
 * URL: /api/v1/cars/{car_id}/history/
 * Optional ``?type=`` narrows which record types are returned. Access is
 * scoped by ``get_object`` (404 if the car is not visible to the caller),
 * so every sub-query is already limited to a car the caller may see.
 */
export const carsHistoryList = async (id: string,
    params?: CarsHistoryListParams, options?: RequestInit): Promise<carsHistoryListResponse> => {

  return customFetch<carsHistoryListResponse>(getCarsHistoryListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsViolationsRetrieveResponse200 = {
  data: CarViolationsResponse
  status: 200
}

export type carsViolationsRetrieveResponseSuccess = (carsViolationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type carsViolationsRetrieveResponse = (carsViolationsRetrieveResponseSuccess)

export const getCarsViolationsRetrieveUrl = (id: string,) => {




  return `/api/v1/cars/${id}/violations/`
}

/**
 * Get basic violation information for a specific car.
 * URL: /api/v1/cars/{car_id}/violations/
 */
export const carsViolationsRetrieve = async (id: string, options?: RequestInit): Promise<carsViolationsRetrieveResponse> => {

  return customFetch<carsViolationsRetrieveResponse>(getCarsViolationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsAggregateRetrieveResponse200 = {
  data: AggregateResult
  status: 200
}

export type carsAggregateRetrieveResponseSuccess = (carsAggregateRetrieveResponse200) & {
  headers: Headers;
};
;

export type carsAggregateRetrieveResponse = (carsAggregateRetrieveResponseSuccess)

export const getCarsAggregateRetrieveUrl = (params: CarsAggregateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/aggregate/?${stringifiedParams}` : `/api/v1/cars/aggregate/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsAggregateRetrieve = async (params: CarsAggregateRetrieveParams, options?: RequestInit): Promise<carsAggregateRetrieveResponse> => {

  return customFetch<carsAggregateRetrieveResponse>(getCarsAggregateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsFormListResponse200 = {
  data: CarForm[]
  status: 200
}

export type carsFormListResponseSuccess = (carsFormListResponse200) & {
  headers: Headers;
};
;

export type carsFormListResponse = (carsFormListResponseSuccess)

export const getCarsFormListUrl = (params?: CarsFormListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/form/?${stringifiedParams}` : `/api/v1/cars/form/`
}

/**
 * Trimmed CarForm list for form dropdowns (SDK: carsFormList).
 *
 * Separate endpoint so the generated type is the precise CarForm shape;
 * the old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 * Honors the same filters as the default list (e.g. property/portfolio).
 */
export const carsFormList = async (params?: CarsFormListParams, options?: RequestInit): Promise<carsFormListResponse> => {

  return customFetch<carsFormListResponse>(getCarsFormListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsKpisByPropertyIdListResponse200 = {
  data: CarInProperty[]
  status: 200
}

export type carsKpisByPropertyIdListResponseSuccess = (carsKpisByPropertyIdListResponse200) & {
  headers: Headers;
};
;

export type carsKpisByPropertyIdListResponse = (carsKpisByPropertyIdListResponseSuccess)

export const getCarsKpisByPropertyIdListUrl = (propertyId: string,
    params?: CarsKpisByPropertyIdListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cars/kpis-by-property-id/${propertyId}/?${stringifiedParams}` : `/api/v1/cars/kpis-by-property-id/${propertyId}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const carsKpisByPropertyIdList = async (propertyId: string,
    params?: CarsKpisByPropertyIdListParams, options?: RequestInit): Promise<carsKpisByPropertyIdListResponse> => {

  return customFetch<carsKpisByPropertyIdListResponse>(getCarsKpisByPropertyIdListUrl(propertyId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type carsMissedMaintenanceRetrieveResponse200 = {
  data: Car
  status: 200
}

export type carsMissedMaintenanceRetrieveResponseSuccess = (carsMissedMaintenanceRetrieveResponse200) & {
  headers: Headers;
};
;

export type carsMissedMaintenanceRetrieveResponse = (carsMissedMaintenanceRetrieveResponseSuccess)

export const getCarsMissedMaintenanceRetrieveUrl = () => {




  return `/api/v1/cars/missed-maintenance/`
}

/**
 * List cars whose maintenance completion fell below the threshold
 * for the given month.
 */
export const carsMissedMaintenanceRetrieve = async ( options?: RequestInit): Promise<carsMissedMaintenanceRetrieveResponse> => {

  return customFetch<carsMissedMaintenanceRetrieveResponse>(getCarsMissedMaintenanceRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


